import React, { useCallback, useState } from 'react'
import { observer } from 'mobx-react'
import PushlyIcon from '@pushly/aqe/lib/components/icons/pushly-icon'
import { useAppState } from '../hooks/use-mobile-service'
import { DomainSelectorSheet } from '../domain-selector/domain-selector-sheet'
import { ProfileMenuSheet } from '../profile/profile-menu-sheet'
import './mobile-header.scss'

export const MobileHeader: React.FC = observer(() => {
    const appState = useAppState()
    const [domainSheetOpen, setDomainSheetOpen] = useState(false)
    const [profileSheetOpen, setProfileSheetOpen] = useState(false)

    const currentDomain = appState.currentDomain

    const domainName = currentDomain?.displayName ?? currentDomain?.name ?? 'Domain'
    const domainIcon = currentDomain?.defaultIconUrl

    const handleDomainTrigger = useCallback(() => {
        setDomainSheetOpen(true)
    }, [])

    const handleDomainSheetClose = useCallback(() => {
        setDomainSheetOpen(false)
    }, [])

    const handleProfileClick = useCallback(() => {
        setProfileSheetOpen(true)
    }, [])

    const handleProfileSheetClose = useCallback(() => {
        setProfileSheetOpen(false)
    }, [])

    return (
        <header className="mobile-header" role="banner">
            <button
                className="mobile-header__domain-trigger"
                onClick={handleDomainTrigger}
                aria-label={`Select domain: ${domainName}`}
                type="button"
            >
                {domainIcon ? (
                    <img className="mobile-header__domain-icon" src={domainIcon} alt="" aria-hidden="true" />
                ) : (
                    <span
                        className="mobile-header__domain-icon mobile-header__domain-icon--placeholder"
                        aria-hidden="true"
                    >
                        {domainName[0]?.toUpperCase() ?? 'D'}
                    </span>
                )}
                <span className="mobile-header__domain-name">{domainName}</span>
            </button>

            <button
                className="mobile-header__profile"
                onClick={handleProfileClick}
                aria-label="Open profile menu"
                type="button"
            >
                <PushlyIcon className="mobile-header__profile-icon" />
            </button>

            <DomainSelectorSheet open={domainSheetOpen} onClose={handleDomainSheetClose} />
            <ProfileMenuSheet open={profileSheetOpen} onClose={handleProfileSheetClose} />
        </header>
    )
})

MobileHeader.displayName = 'MobileHeader'
